import { Alert } from '@cmsgov/design-system'
import { MyInternalLink } from 'components/MyLink'
import { Trans, useTranslation } from 'react-i18next'

export function RecentPaymentAlert () {
  const { t } = useTranslation('makeAPaymentPage', { keyPrefix: 'payYourPremium.recentPaymentAlert' })

  return (
    <Alert heading={t('heading')} variation='warn' className='ds-u-measure--wide ds-u-margin-bottom--3'>
      <Trans t={t} i18nKey="content" components={{
        link1: <LinkToPaymentHistory />
      }} />
    </Alert>
  )
}

export default RecentPaymentAlert

function LinkToPaymentHistory ({ children }: {children?: React.ReactNode}) {
  return <MyInternalLink to="/premiums/history">{children}</MyInternalLink>
}
